import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiRatingModule } from "@taiga-ui/kit";
import { KwikUIStarRatingComponent } from "./star-rating.component";

@NgModule({
  declarations: [KwikUIStarRatingComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TuiRatingModule],
  exports: [KwikUIStarRatingComponent]
})
export class KwikUIStarRatingModule {}
